module.exports = __webpack_public_path__ + "img/wechat-textbar.b15dda44.png";